<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    uniqueId: {
      type: String,
      default: '01234567-0123-0123-0123-0123456789ab',
    },
  },
};
</script>

<template>
  <div>
    <div v-if="list.length <= 1">
      {{ list.length == 1 ? list[0] : '' }}
    </div>
    <div v-else>
      <div :id="'popover-primary-' + uniqueId" class="clickable-text">
        {{
          list[0] +
          ' (' +
          $t('general.and') +
          ' ' +
          (list.length - 1).toString() +
          ' ' +
          $t('general.more') +
          '...)'
        }}
      </div>
      <b-popover
        :target="'popover-primary-' + uniqueId"
        triggers="hover"
        placement="top"
        variant="primary"
      >
        <div style="font-size: 1.2em">
          <div v-for="(item, index) of list" :key="index">
            {{ item }}
          </div>
        </div>
      </b-popover>
    </div>
  </div>
</template>

<style scoped>
</style>